import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Component } from 'types';

type CreateComponentData = {
  name: string;
  description?: string;
  project: string;
  lead?: string;
  org: string;
};

const createComponent = async (componentData: CreateComponentData): Promise<Component> => {
  const { data } = await customAxios.post<Component>('/components', componentData);
  return data;
};

export const useCreateComponent = (orgId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createComponent,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['components', orgId] }).catch(() => undefined);
    },
  });
};
